import { PermissionsEnum } from "@/auth/interfaces";
import { VerDocumentosHabilitantesContractuales } from "@/erp/supervision-venta-corporativa/solicitudes-pendientes/shared/componente";
// EstadoFactibilidadCorporativaENUM
import { hasPermission, ROUTER_PATHS, TABLE_CONSTANTS_COLUMS, useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { useTableColumnsCapacidadCorporativo } from "@/shared/hooks/useTableColumnsCapacidadCorporativo";
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo";

import { Visibility } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SolucionCosteadaPage() {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_factibilidadcoorporativa
  ]);

  const [open, setOpen] = useState(false);
  const [documentsArray, setDocumentsArray] = useState<any>({});

  const navigate = useNavigate();


  ///* table
  const {
    pagination,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* fetch data
  // const {
  //   data: ivasPagingRes,
  //   isLoading,
  //   isRefetching,
  // } = useGetCapacidadCorporativo({
  //   page: pageIndex + 1,
  //   page_size: pageSize,
  //   nombre: searchTerm,
  //   ...filterObject,
  //   filterByState: false,
  // });
  const {
      data: factCoorporativaPagingRes,
      isLoading: isLoadingFactCoorporativa,
      isRefetching: isRefetchingFactCoorporativa,
    } = useFetchGetfactibilidadCorporativos(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        ...filterObject,
        filterByState: false,
        // condicion_venta_isnull_or_void: true
      }
    )

  const { columnsSolucionCosteada } = useTableColumnsCapacidadCorporativo({setOpen, setDocumentsArray})

  return (
    <SingleTableBoxScene
      title="Solución Costeada"
      // urlRedirect={`${ROUTER_PATHS.ventasCorporativas.capacidadCorporativaCrearNav}`}
      // enableRedirect={hasPermission(PermissionsEnum.api_add_capacidadcoorporativa)}
    >
      <GeneralTable<IFactibilidadCorporativo>
        columns={columnsSolucionCosteada}
        data={factCoorporativaPagingRes?.data?.data || []}
        //
        editIcon={<Visibility/>}
        toolTipTitleEditIcon="Revisar"
        isLoading={isLoadingFactCoorporativa}
        isRefetching={isRefetchingFactCoorporativa}
        // // search
        enableGlobalFilter={false}
        // // filters - llega al back
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableSorting={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={factCoorporativaPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={hasPermission(PermissionsEnum.api_change_plancoorporativo)}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        // crud
        canEdit={hasPermission(PermissionsEnum.api_change_factibilidadcoorporativa)}
        canEditByRowData={(v)=>(
          !!v.aceptado_factibilidad
          && !!v.preaprobado_inventario
          // v.estado_factibilidad===EstadoFactibilidadCorporativaENUM.APROBADO
          // || v.estado_factibilidad===EstadoFactibilidadCorporativaENUM.EN_REVISION
          // || v.estado_factibilidad===EstadoFactibilidadCorporativaENUM.CORREGIDO
          // || (v.estado_factibilidad===EstadoFactibilidadCorporativaENUM.EN_GESTION && v.preaprobado_inventario!)
          )
        }
        onEdit={(value) => {
          navigate(`${ROUTER_PATHS.ventasCorporativas.solucionCosteadaCorporativoNav}/${value.id_factibilidad_coorporativa}`)
        }}
        canDelete={false}
      />
      <VerDocumentosHabilitantesContractuales
          open={open}
          setOpen={setOpen}
          documentsArray={documentsArray}
        />
    </SingleTableBoxScene>
  );

}